import ApiClient from './ApiClient';

class TemplatesAPI extends ApiClient {
  constructor() {
    super('templates', { accountScoped: true });
  }

  async create(payload){
    const isForm = (typeof FormData !== 'undefined') && (payload instanceof FormData);
    return await axios.post(this.url, payload, isForm ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined);
  }

  async getTemplates(){
    return await axios.get(`${this.url}`);
  }

  async deleteTemplate(name, providerConfig){
    return await axios.delete(`${this.url}/${name}`, {
      data: {
        provider_config: providerConfig
      }
    });
  }
}

export default new TemplatesAPI();
